export default "__VITE_ASSET__Du8XnoX1__"